import fetch from "auth/FetchInterceptor";

const NOTIFICATIONS_PREFIX = "/notifications";

// Les messages de chat ont leur propre badge (NavCommunication) : on les exclut de la cloche.
export const EXCLUDED_NOTIFICATION_TYPES = ["chat_message"];

const excludeParams = { excludeTypes: EXCLUDED_NOTIFICATION_TYPES.join(",") };

const NotificationsService = {};

NotificationsService.getNotifications = async (params = {}) =>
  fetch({
    url: `${NOTIFICATIONS_PREFIX}`,
    method: "GET",
    params: { ...excludeParams, ...params },
  });

NotificationsService.getUnreadCount = async () =>
  fetch({
    url: `${NOTIFICATIONS_PREFIX}/unread/count`,
    method: "GET",
    params: excludeParams,
  });

NotificationsService.markAsRead = async (notificationId) =>
  fetch({
    url: `${NOTIFICATIONS_PREFIX}/${notificationId}/read`,
    method: "PATCH",
  });

NotificationsService.markAllAsRead = async () =>
  fetch({
    url: `${NOTIFICATIONS_PREFIX}/read-all`,
    method: "PATCH",
    params: excludeParams,
  });

NotificationsService.deleteNotification = async (notificationId) =>
  fetch({
    url: `${NOTIFICATIONS_PREFIX}/${notificationId}`,
    method: "DELETE",
  });

export default NotificationsService;
